




































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { TeacherEvaluationDto, TrainingClassType } from '@/api/models';
import { Notify, Dialog } from 'vant';
import { keys } from 'lodash';
@Component({})
export default class FeedBack extends Vue {
  loading: boolean = false;
  finished: boolean = false;
  teacherMap: { [key: string]: number } = {
    jxtd: 0,
    pxnr: 0,
    skjq: 0,
    pxxg: 0,
    zhpj: 0,
  };
  trainingAgencyMap: { [key: string]: number } = {
    hqbz: 0,
    kcap: 0,
    skjq: 0,
  };
  organizerMap: { [key: string]: number } = {
    zzgl: 0,
    zhpj: 0,
  };
  teacherEvaluationItem: any = {};
  trainingAgencyEvaluationItem: any = {};
  organizerEvaluationItem: any = {};
  form: any = {
    id: '',
    publicTrainingClassId: '',
    className: '',
    trainingSchedulingId: '',
    courseName: '',
    teacherId: '',
    teacherName: '',
    deptId: '',
    content: '',
    storage: '',
    dicValue: {},
    sponsor: '',
  };
  feedbackTitle: string = '';
  teacherDetail: any = {};
  comprehensiveDetail: any = {};
  comprehensiveForm: any = {
    id: '',
    trainingAgencyId: '',
    trainingAgencyName: '',
    classId: '',
    className: '',
    deptId: '',
    trainingAgencyStorage: '',
    organizerStorage: '',
    Content: '',
  };
  onClickLeft() {
    this.$router.go(-1);
  }
  mounted() {
    window.addEventListener('pagehide', this.onPageUnload);
    //获取所有评价项目
    this.getEvaluateItems();
    if (this.$route.params.feedbackTitle) {
      this.feedbackTitle = this.$route.params.feedbackTitle;
      if (this.feedbackTitle == '评价教师') {
        this.teacherDetail = this.$route.params.teacherDetail;
        this.teacherDetail.className = this.$route.params.className;
        this.teacherDetail.trainType = this.$route.params.trainType;
      }
      if (this.feedbackTitle == '综合评价') {
        this.comprehensiveDetail = this.$route.params.comprehensiveDetail;
      }
    } else {
      let memoryFeedbackTitle = sessionStorage.getItem('feedbackTitle');
      this.feedbackTitle = JSON.parse(memoryFeedbackTitle!);
      if (this.feedbackTitle == '评价教师') {
        let memoryTeacherDetail = sessionStorage.getItem('teacherDetail');
        this.teacherDetail = JSON.parse(memoryTeacherDetail!);
      }
      if (this.feedbackTitle == '综合评价') {
        let memoryComprehensiveDetail = sessionStorage.getItem('comprehensiveDetail');
        this.comprehensiveDetail = JSON.parse(memoryComprehensiveDetail!);
      }
    }
  }
  //页面刷新
  onPageUnload() {
    sessionStorage.setItem('feedbackTitle', JSON.stringify(this.feedbackTitle));
    if (this.feedbackTitle == '评价教师') {
      sessionStorage.setItem('teacherDetail', JSON.stringify(this.teacherDetail));
    }
    if (this.feedbackTitle == '综合评价') {
      sessionStorage.setItem('comprehensiveDetail', JSON.stringify(this.comprehensiveDetail));
    }
  }
  async getEvaluateItems() {
    const { data } = await api.TeacherEvaluation.getEvaluateItems_GET();
    this.teacherEvaluationItem = data.teacherEvaluateDic;
    this.trainingAgencyEvaluationItem = data.trainingAgencyEvaluateDic;
    this.organizerEvaluationItem = data.organizerEvaluateDic;
  }
  //教师评价提交
  async teacherEvaluationSubmit() {
    this.form.publicTrainingClassId = this.teacherDetail.classId;
    this.form.className = this.teacherDetail.className;
    this.form.trainingSchedulingId = this.teacherDetail.trainingSchedulingId;
    this.form.courseName = this.teacherDetail.courseName;
    this.form.teacherId = this.teacherDetail.systemTeacherId;
    this.form.teacherName = this.teacherDetail.teacher;
    this.form.deptId = this.teacherDetail.deptId;
    this.form.storage = JSON.stringify(this.teacherMap);
    try {
      const { data, success, message } = await api.TeacherEvaluation.save_POST(this.form);
      if (success) {
        //评价成功，清空form
        for (let k of Object.keys(this.form)) {
          Vue.delete(this.form, k);
        }
        console.log('评价成功后的form', this.form);
        Dialog.alert({
          message: '评价成功',
        }).then(() => {
          this.$router.push({
            name: 'myFeedbacks',
            params: { feedbackStatus: '教师评价' },
          });
        });
      } else {
        Dialog.alert({
          message: '评价失败',
        });
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  get TrainingClassType() {
    return TrainingClassType;
  }

  //综合评价提交
  async EvaluationSubmit() {
    this.comprehensiveForm.trainingAgencyId = this.comprehensiveDetail.trainingAgencyId;
    this.comprehensiveForm.trainingAgencyName = this.comprehensiveDetail.trainingAgencyName;
    this.comprehensiveForm.classId = this.comprehensiveDetail.classId;
    this.comprehensiveForm.className = this.comprehensiveDetail.className;
    this.comprehensiveForm.deptId = this.comprehensiveDetail.deptId;
    this.comprehensiveForm.classType = this.comprehensiveDetail.classType;
    this.comprehensiveForm.trainingAgencyStorage = JSON.stringify(this.trainingAgencyMap);
    this.comprehensiveForm.organizerStorage = JSON.stringify(this.organizerMap);

    // if (this.comprehensiveDetail.classType == TrainingClassType.单位自主计划培训班) {
    this.comprehensiveForm.sponsor = this.comprehensiveDetail.deptName;
    // }
    // if (this.comprehensiveDetail.classType == TrainingClassType.干教调训班) {
    //   this.comprehensiveForm.deptName = this.comprehensiveDetail.deptName;
    // }

    try {
      const { data, success, message } = await api.ComperhensiveEvaluation.save_POST(this.comprehensiveForm);
      if (success) {
        //评价成功，清空form
        for (let k of Object.keys(this.comprehensiveForm)) {
          Vue.delete(this.comprehensiveForm, k);
        }
        Dialog.alert({
          message: '评价成功',
        }).then(() => {
          this.$router.push({
            name: 'myFeedbacks',
            params: { feedbackStatus: '班次评价' },
          });
        });
      } else {
        Dialog.alert({
          message: '评价失败',
        });
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
}
